/* eslint-disable */
export default {
  'fr-FR': {
    common: {
      NAME_HOLDER: "Nom *",
      LAST_NAME_HOLDER: "Prénom *",
      EMAIL_HOLDER: "Adresse email *",
      PASS_HOLDER: "Créez un mot de passe *",
      REPEAT_PASS_HOLDER: "Répétez le mot de passe *",
      BUTTON_EMAIL_SIGN_UP: "Créez votre compte Time Out",

      TERMS_AND_CONDITIONS: "termes et conditions d\'utilisation",
      PRIVACY_POLICY: "politique de confidentialité",

      NEWSLETTER_CONSENT: "J’accepte de recevoir des mails de Time Out au sujet des dernières news, évents et offres promotionnelles de nos partenaires.",
      TERM_OF_USE: "J'ai lu et j'accepte les {{terms_and_conditions}} et la {{privacy_policy}} de Time Out",
      TERM_OF_USE_WITH_NEWSLETTERS: "J'ai lu et j'accepte les {{terms_and_conditions}} et la {{privacy_policy}} de Time Out, y compris l'inscription à la newsletter",

      HEADER_TITLE: "Crééz un compte Time Out",
      JOIN_FB: "S'inscrire avec Facebook",
      JOIN_TW: "S'inscrire avec Twitter",
      JOIN_GG: "S'inscrire avec Google",
      JOIN_EM: "S'inscrire avec son email",
      ALREADY_HAVE: "Vous avez déjà un compte Time Out?",
      CREATE_ACCOUNT_LOG_IN: "Se connecter",

      SIGN_IN_TITLE: "S'enregistrer",
      SIGN_IN_FB: "Se connecter via Facebook",
      SIGN_IN_TW: "Se connecter via Twitter",
      SIGN_IN_GG: "Se connecter via Google",
      SIGN_IN_EM: "Se connecter via son email",
      YOUR_EMAIL: "Votre adresse email",
      YOUR_PASSWORD: "Votre mot de passe",
      REMEMBER: "Se souvenir de moi",
      FORGOT: "Oublié?",
      HAVE_ACCOUNT_YET: "Vous n'avez pas encore de compte Time Out?",
      JOIN_HERE: "S'inscrire ici",
      ALMOST_THERE: "Presque là",

      FORGOT_HEADER: "Vous avez oublié votre mot de passe?",
      FORGOT_SUBTITLE: "Aucun problème. Entrez votre adresse email ci-dessous, nous vous enverrons un lien pour le réinitialiser.",
      SEND_LINK: "Envoyer le lien",

      RECEIVE_EMAIL: "Merci, vous allez rapidement recevoir un email",
      MANAGE_ACCOUNT: "Gérer votre compte",
      EDIT_DETAILS_HERE: "Vous pouvez paramétrer votre compte ici",
      FIRST_NAME: "Nom",
      LAST_NAME: "Prénom",
      SCREEN_NAME: "Nom du profil",
      EMAIL: "Adresse email",
      ACCOUNT_DETAILS: "Détails du compte",
      PASSWORD: "Mot de passe",
      SAVE_CHANGES: "Sauvegarder les modifications",
      UPLOAD_PIC: "Télécharger une nouvelle photo de profil",
      CHOOSE_PHOTO: "Choisissez une photo à télécharger (jusqu'à 2MB).",
      CLOSE_ACCOUNT: "Fermer mon compte",
      PASSWORD_BELOW: "Vous pouvez modifier votre mot de passe ci-dessous",
      CURRENT_PASSWORD: "Mot de passe actuel",
      NEW_PASSWORD: "Nouveau mot de passe",
      REPEAT_PASSWORD: "Répétez le nouveau mot de passe",

      OOPS: "Oops,",
      ERROR_404_OCCURED: "Une erreur est survenue…",
      ERROR_404_INFO: "Cette page a changé d'adresse ou n'existe plus.",
      ERROR_500_TITLE: "Le serveur indique que",
      SMTH_BROKEN: "Quelque chose est cassé.",
      INTERNAL_RED: "Une erreur de type 500 Internal Server Error est survenue",
      LET_KNOW_RED: "SVP indiquez-nous ce qui a provoqué cette erreur, nous allons y remédier au plus vite. Désolé pour le dérangement",
      ERROR_500_INFO: "what you were doing when this error occurred. We will fix it as soon as possible. Sorry for any inconvenience caused.",

      EMAIL_ERROR: "Entrer une adresse email valide",
      FIRST_NAME_ERROR: "Entrer votre prenom",
      LAST_NAME_ERROR: "Entrer votre nom",
      TERM_OF_USE_ERROR: "Vous devez accepter nos conditions d'utilisation",
      SIGN_IN_VALIDATION_ERROR: "Email ou mot de passe erroné. Réessayez SVP",
      ACCOUNT_PASSWORDS_VALIDATION: "Les mots de passe ne correspondent pas",
      WAS_IT: "C'est de notre faute?",
      DELETE_ACCOUNT_TEXT: "Vous nous quittez déjà? Qu'est-ce qui vous pousse à vouloir supprimer votre compte?",
      DELETE_ACCOUNT: "Supprimer le compte",
      CANCEL: "Annuler",

      UPDATE_PASSWORD: "Modifiez votre mot de passe",
      PASSWORD_UPDATE_SUCCESS: "Votre mot de passe a été réinitialisé",
      ERROR_PASSWORD_LENGTH: "Le mot de passe doit contenir au moins 6 caractères",

      ERROR_MISSING_SITE_PARAMETER: "Paramètre d'application requis manquant: site",
      ERROR_ALREADY_REGISTERED: "Vous êtes déjà enregistré(e) via l'email d'inscription. Veuillez vous connecter en utilisant {{email}}",
    }
  }
}



// WEBPACK FOOTER //
// ./translations/fr-FR.js